import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JobAction, JobTableData, JobTablePaginationState } from 'modules/jobManager/types';

export const initialJobTablePaginationState: JobTablePaginationState = {
  page: 1,
  pageSize: 10,
  count: 0,
};

export const jobTablePaginationReducer = (
  state = initialJobTablePaginationState,
  action?: JobAction,
) => {
  switch (action?.type) {
    case ActionTypes.SET_TABLE_PAGE: {
      return {
        ...state,
        page: action?.payload ?? state.page,
      };
    }

    case ActionTypes.SET_TABLE_PAGE_SIZE: {
      return {
        ...state,
        pageSize: action?.payload ?? state.pageSize,
      };
    }

    case ActionTypes.FETCH_TABLE_DATA_RESPONSE: {
      const { info } = action?.payload as JobTableData;

      return {
        page: info?.page || state.page,
        pageSize: info?.limit || state.pageSize,
        count: info?.count || state.count,
      };
    }

    default:
      return state;
  }
};
